<template>
  <div class="c_list_item input-mk">
    <span class="icon" :class="{ active: keyword }"></span>
    <AutoComplete
      ref="autoComplete"
      class="search-input"
      size="small"
      v-model="keyword"
      :data="leasonListFilter"
      @on-focus="handleFocus"
      @on-select="handleSelect"
      @on-blur="handleBlur"
      placeholder="其他原因"
    ></AutoComplete>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    patientCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      leasonList: [],
      keyword: "",
      dsj: null,
      isSelect: false, //是否选择
    };
  },
  computed: {
    leasonListFilter() {
      return this.keyword
        ? this.leasonList.filter((item) => {
            return item.indexOf(this.keyword) > -1;
          })
        : this.leasonList;
    },
  },
  methods: {
    handleBlur() {
      this.addData();
    },
    handleSelect() {
      this.addData();
    },
    addData() {
      clearTimeout(this.dsj);
      this.dsj = setTimeout(() => {
        if (this.keyword.trim()) {
          if (!this.info.children.find((item) => item.label === this.keyword)) {
            this.info.children.push({
              label: this.keyword,
              active: true,
              isRoot: false,
              isShow: true,
            });
            this.temporarilySave(this.keyword);
          } else {
            this.$Message.error("该原因已存在");
          }
          this.keyword = "";
        }
      }, 300);
    },
    temporarilySave(str) {
      let d = sessionStorage.getItem("causeInput_" + this.info.value);
      let list = d ? JSON.parse(d) : [];
      list.push(str);
      sessionStorage.setItem(
        "causeInput_" + this.info.value,
        JSON.stringify(list)
      );
    },
    handleFocus() {
      this.api2("getUserEtiologyReasonByEtiologyId", {
        etiologyId: this.info.value,
        patientCode: this.patientCode,
      }).then((res) => {
        let d = sessionStorage.getItem("causeInput_" + this.info.value);
        let list = d ? JSON.parse(d) : [];
        let arr = [
          ...new Set([
            ...this.leasonList,
            ...res.result.map((i) => i.bottomReason),
            ...list,
          ]),
        ];
        this.leasonList = arr;
      });
    },
  },
  mounted() {
    let inputNode = this.$refs.autoComplete.$el.querySelector("input");
    inputNode.addEventListener("keyup", (e) => {
      setTimeout(() => {
        if (e.keyCode == 13) {
          this.handleSelect();
        }
      }, 200);
    });
  },
};
</script>

<style lang="scss" scoped>
.search-input {
}
</style>